import { render, staticRenderFns } from "./ActionIssuePolicy.vue?vue&type=template&id=3d390675"
import script from "./ActionIssuePolicy.vue?vue&type=script&lang=js"
export * from "./ActionIssuePolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports